/**
 * 初期処理
 *
 */
$(window).on('load', function() {
  // 連絡方法選択時の制御
	oh_click_contact_way();

  // 住所コピー
  oh_copy_address('0');
});

/**
 * 連絡方法選択時の制御
 *
 */
(function () {
  $("[id^=customer_contact_way]").on('change',function() {
		oh_click_contact_way();
	});
}());
var oh_click_contact_way = function() {
  oh_click_contact_way_toggle_class($('#customer_address_label'));
  // oh_click_contact_way_toggle_class($('#customer_address2').closest('.c-form-item__input-row').siblings('.c-form-item__label'));
};
var oh_click_contact_way_toggle_class = function ( el ) {
  // 初期化
  el.removeClass('--optional');
  el.removeClass('--required');
  // クラス付与
  if ($('#customer_contact_way4').prop('checked')) {
    el.addClass('--required');
  } else {
    el.addClass('--optional');
  }
};

/**
 * 「上記住所と同じ」チェック時
 */
(function () {
  $("#contact_same_address").on('click',function() {
		oh_copy_address('1');
	});

  $('#customer_zip_cd').bind('change',function() {
    if($('#contact_same_address').prop('checked')) {
      $('#contact_zip_cd').val($('#customer_zip_cd').val());
    }
  });
  $('#customer_address1').bind('change',function() {
    if($('#contact_same_address').prop('checked')) {
      $('#contact_address1').val($('#customer_address1').val());
    }
  });
  $('#customer_address2').bind('change',function() {
    if($('#contact_same_address').prop('checked')) {
      $('#contact_address2').val($('#customer_address2').val());
    }
  });
  $('#customer_mansion_nm').bind('change',function() {
    if($('#contact_same_address').prop('checked')) {
      $('#contact_mansion_nm').val($('#customer_mansion_nm').val());
    }
  });
  $('#customer_room_no').bind('change',function() {
    if($('#contact_same_address').prop('checked')) {
      $('#contact_room_no').val($('#customer_room_no').val());
    }
  });
}());

/**
 * 住所のコピー
 * @param {*} flg
 */
var oh_copy_address = function(flg) {
  if($('#contact_same_address').prop('checked')) {
    $('#contact_same_address').val('1');
    $('#contact_zip_cd').val($('#customer_zip_cd').val());
    $('#contact_address1').val($('#customer_address1').val());
    $('#contact_address2').val($('#customer_address2').val());
    $('#contact_mansion_nm').val($('#customer_mansion_nm').val());
    $('#contact_room_no').val($('#customer_room_no').val());

    $('#contact_zip_cd').attr('readonly',true);
    $('#contact_address1').attr('readonly',true);
    $('#contact_address2').attr('readonly',true);
    $('#contact_mansion_nm').attr('readonly',true);
    $('#contact_room_no').attr('readonly',true);
  } else {
    $('#contact_same_address').val('0');
    $('#contact_zip_cd').removeAttr('readonly',false);
    $('#contact_address1').removeAttr('readonly',false);
    $('#contact_address2').removeAttr('readonly',false);
    $('#contact_mansion_nm').removeAttr('readonly',false);
    $('#contact_room_no').removeAttr('readonly',false);
    if (flg == '1') {
      $('#contact_zip_cd').val('');
      $('#contact_address1').val('');
      $('#contact_address2').val('');
      $('#contact_mansion_nm').val('');
      $('#contact_room_no').val('');
    }
  }
};

/**
 * ふりがな自動入力
 */
 $(function() {
  $.fn.autoKana('#customer_nm', '#customer_kn');
});
